import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { AuthService } from '../service/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthguardAAToken {

  constructor(private readonly userService: AuthService, private readonly router: Router) {
  }

  canActivate(route: ActivatedRouteSnapshot): boolean {

    const tokenId: string = route.queryParams['tokenId'];

    if (null == tokenId) {
      this.router.navigate(['unauthorized']);
    }
    sessionStorage.setItem('aaToken', tokenId);
    this.userService.getViewAAGeneratedLetter().subscribe({
      next: (data: string) => {
        if ("FAIL" == data) {
          this.router.navigate(['unauthorized']);
        } else { //SUCCESS containing verifyId
          localStorage.setItem('verifyIdLocal', data);
          sessionStorage.setItem('verifyId', data);
          this.router.navigate(['loginLatestAAGenLetter']);
        }
      },
      error: () => {
        this.router.navigate(['unauthorized']);
      }
    });

    return true;
  }

}
